module.exports = __webpack_public_path__ + "static/media/448198482_474584584939196_2400025422692794137_n.982d4574.jpg";